import { useState, useEffect } from 'react'
import { ArrowUpDown } from 'lucide-react'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function Hero() {
  const [exchangeRate, setExchangeRate] = useState({
    buy: "19.80",
    sell: "20.20",
    loading: true,
    lastUpdate: ""
  })

  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch(`${API_URL}/api/rates`)
        if (!response.ok) throw new Error('Error al obtener datos')
        const rates = await response.json()
        setExchangeRate({
          buy: rates.buy,
          sell: rates.sell,
          loading: false,
          lastUpdate: rates.lastUpdate
        })
      } catch (error) {
        console.error('Error al cargar tipo de cambio:', error)
        setExchangeRate({
          buy: "19.80",
          sell: "20.20",
          loading: false,
          lastUpdate: "Error al cargar"
        })
      }
    }
    fetchExchangeRate()
    const interval = setInterval(fetchExchangeRate, 30000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section className="relative flex items-center justify-center hero-section" id="inicio">
      {/* Hero background */}
      <div
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage: "url('/images/banner.jpg')",
          backgroundPosition: "center center",
          zIndex: 1,
        }}
      >
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full hero-content">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <div className="text-center max-w-3xl mx-auto">
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-balance hero-title"
                style={{ color: "var(--brand-gold)" }}
              >
                CAMBIA TUS DIVISAS
                <br />
                AL MEJOR TIPO DE CAMBIO
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl mb-8 text-white opacity-90">
                Dólares • Pesos • Transferencias
              </p>

              {/* Letrero de Tipo de Cambio */}
              {!exchangeRate.loading && (
                <div className="hero-exchange-badge fade-in">
                  <div className="hero-badge-label">Dólar Hoy</div>
                  <div className="hero-badge-rates">
                    <div className="hero-badge-rate">
                      <span className="hero-badge-rate-label">Compra</span>
                      <span className="hero-badge-rate-value">${exchangeRate.buy}</span>
                    </div>
                    <ArrowUpDown className="w-4 h-4" style={{ color: 'rgba(255,255,255,0.4)' }} />
                    <div className="hero-badge-rate">
                      <span className="hero-badge-rate-label">Venta</span>
                      <span className="hero-badge-rate-value">${exchangeRate.sell}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-8">
                <a
                  href="#stats-section"
                  className="btn-rounded px-10 py-4 font-semibold transition-all inline-block text-lg hero-cta"
                  style={{
                    backgroundColor: "var(--white)",
                    color: "var(--brand-red)",
                    boxShadow: "0 8px 30px rgba(16,16,16,0.12)",
                  }}
                >
                  VER TIPO DE CAMBIO
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}